import {AbstractModel, DateConverter, JsonObject, JsonProperty} from 'projects/core/src/public-api';

@JsonObject('model.BacklogActivity')
export class BacklogActivity extends AbstractModel {

    @JsonProperty(Number, 'id')
    id = 0;

    @JsonProperty(Boolean, 'ready')
    ready = false;

    @JsonProperty(DateConverter, 'startDate')
    startDate: Date = new Date();

    @JsonProperty(DateConverter, 'endDate')
    endDate: Date = new Date();

    @JsonProperty(Number, 'jobId')
    jobId = 0;

    @JsonProperty(String, 'jobName')
    jobName = '';

    @JsonProperty(String, 'jobNumber')
    jobNumber = '';

    @JsonProperty(DateConverter, 'jobDueDate')
    jobDueDate: Date = new Date();

    @JsonProperty(DateConverter, 'assignDate')
    assignDate: Date = new Date();

    @JsonProperty(DateConverter, 'createdDate')
    createdDate: Date = new Date();

    @JsonProperty(DateConverter, 'toggleDate')
    toggleDate: Date = new Date();

    @JsonProperty(Boolean, 'jobSalesListReady')
    jobSalesListReady = false;

    @JsonProperty(Number, 'jobTypeId')
    jobTypeId = 0;

    @JsonProperty(String, 'jobTypeShortTitle')
    jobTypeShortTitle = '';

    @JsonProperty(String, 'jobTypeColor')
    jobTypeColor = '';

    @JsonProperty(Number, 'jobComplexityId')
    jobComplexityId = 0;

    @JsonProperty(String, 'jobComplexityShortTitle')
    jobComplexityShortTitle = '';

    @JsonProperty(String, 'jobComplexityColor')
    jobComplexityColor = '';

    @JsonProperty(Number, 'jobPaymentStatusId')
    jobPaymentStatusId = 0;

    @JsonProperty(String, 'jobPaymentStatusShortTitle')
    jobPaymentStatusShortTitle = '';

    @JsonProperty(String, 'jobPaymentStatusColor')
    jobPaymentStatusColor = '';

    @JsonProperty(Number, 'duration')
    duration?: number;

    @JsonProperty(String, 'statusChangeReason')
    statusChangeReason = '';

    @JsonProperty(Number, 'userId')
    userId = 0;

    @JsonProperty(String, 'userName')
    userName = '';

    @JsonProperty(String, 'userShortCode')
    userShortCode = '';

    @JsonProperty(String, 'userBgColor')
    userBgColor = '';

    @JsonProperty(Number, 'typeId')
    typeId: number;

    @JsonProperty(String, 'typeShortCode')
    typeShortCode = '';

    @JsonProperty(String, 'typeColor')
    typeColor = '';


    isEditing = false;
}